import React, { useEffect, useState } from "react"

const AnimatedLine = () => {
  const [isWidth, setWidth] = useState(0); // Default to 0 to avoid SSR issues

  useEffect(() => {
    // Ensure this runs only in the browser
    if (typeof window !== "undefined") {
      setWidth(window.innerWidth); // Set initial width

      const handleResize = () => setWidth(window.innerWidth);

      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const svgStyles = {
    path: {
      animation: "animateLine 50s linear infinite",
      strokeDasharray: "4 4",
    },
  }
  return (
    <>
      <style>
        {`
          @keyframes animateLine {
            0% {
              stroke-dashoffset: 0;
            }
            100% {
              stroke-dashoffset: -2000px;
            }
          }
        `}
      </style>
      {isWidth >= 1410 && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1332"
          height="670"
          viewBox="0 0 1332 670"
          fill="none"
        >
          <path
            d="M666 10H25.0001C11.7452 10 1.00005 20.7452 1.00005 34V116C1.00005 129.255 11.7452 140 25.0001 140H669.531H1307C1320.25 140 1331 150.745 1331 164V246C1331 259.255 1320.25 270 1307 270H25.0001C11.7452 270 1.00005 280.745 1.00005 294V376C1.00005 389.255 11.7452 400 25 400H1307C1320.25 400 1331 410.745 1331 424V506C1331 519.255 1320.25 530 1307 530H25.0001C11.7452 530 1.00005 540.745 1.00005 554V636C1.00005 649.255 11.7452 660 25.0001 660H670.119"
            stroke="black"
            stroke-dasharray="4 4"
            style={svgStyles.path}
          />
          <circle cx="666" cy="10" r="10" fill="#E95444" />
          <circle cx="666" cy="660" r="10" fill="black" />
          <path d="M673 140L658 131L658 149L673 140Z" fill="#E95444" />
          <path d="M670 400L655 391L655 409L670 400Z" fill="#E95444" />
          <path d="M655 270L670 261L670 279L655 270Z" fill="#E95444" />
          <path d="M662 530L677 521L677 539L662 530Z" fill="#E95444" />
          <path d="M347 660L332 651L332 669L347 660Z" fill="#E95444" />
          <path d="M332 10L347 1.00005L347 19L332 10Z" fill="#E95444" />
        </svg>
      )}

      {isWidth >= 1200 && isWidth <= 1409 && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1202"
          height="670"
          viewBox="0 0 1202 670"
          fill="none"
        >
          <path
            d="M601 10H25.0001C11.7452 10 1.00004 20.7452 1.00004 34V116C1.00004 129.255 11.7452 140 25 140H604.186H1177C1190.25 140 1201 150.745 1201 164V246C1201 259.255 1190.25 270 1177 270H25C11.7452 270 1.00004 280.745 1.00004 294V376C1.00004 389.255 11.7452 400 25 400H1177C1190.25 400 1201 410.745 1201 424V506C1201 519.255 1190.25 530 1177 530H25C11.7452 530 1.00004 540.745 1.00004 554V636C1.00004 649.255 11.7452 660 25 660H604.717"
            style={svgStyles.path}
            stroke="black"
            stroke-dasharray="4 4"
          />
          <circle cx="601" cy="10" r="10" fill="#E95444" />
          <circle cx="601" cy="660" r="10" fill="black" />
          <path d="M608 140L593 131L593 149L608 140Z" fill="#E95444" />
          <path d="M604 400L589 391L589 409L604 400Z" fill="#E95444" />
          <path d="M590 270L605 261L605 279L590 270Z" fill="#E95444" />
          <path d="M589 530L604 521L604 539L589 530Z" fill="#E95444" />
          <path d="M294 660L279 651L279 669L294 660Z" fill="#E95444" />
          <path d="M277 10L292 1.00005L292 19L277 10Z" fill="#E95444" />
        </svg>
      )}

      {isWidth >= 768 && isWidth <= 1199 && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="770"
          height="670"
          viewBox="0 0 770 670"
          fill="none"
        >
          <path
            d="M385 10H25C11.7452 10 1 20.7452 1 34V116C1 129.255 11.7452 140 25 140H387.039H745C758.255 140 769 150.745 769 164V246C769 259.255 758.255 270 745 270H25C11.7452 270 1 280.745 1 294V376C1 389.255 11.7452 400 25 400H745C758.255 400 769 410.745 769 424V506C769 519.255 758.255 530 745 530H25C11.7452 530 1 540.745 1 554V636C1 649.255 11.7452 660 25 660H387.379"
            stroke="black"
            stroke-dasharray="4 4"
            style={svgStyles.path}
          />
          <circle cx="385" cy="10" r="10" fill="#E95444" />
          <circle cx="385" cy="660" r="10" fill="black" />
          <path d="M390 140L375 131L375 149L390 140Z" fill="#E95444" />
          <path d="M388 400L373 391L373 409L388 400Z" fill="#E95444" />
          <path d="M374 270L389 261L389 279L374 270Z" fill="#E95444" />
          <path d="M373 530L388 521L388 539L373 530Z" fill="#E95444" />
          <path d="M205 660L190 651L190 669L205 660Z" fill="#E95444" />
          <path d="M190 10L205 1.00005L205 19L190 10Z" fill="#E95444" />
        </svg>
      )}

      {isWidth >= 320 && isWidth <= 767 && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="322"
          height="670"
          viewBox="0 0 322 670"
          fill="none"
        >
          <path
            d="M161 10H25C11.7452 10 1 20.7452 1 34V116C1 129.255 11.7452 140 25 140H161.85H297C310.255 140 321 150.745 321 164V246C321 259.255 310.255 270 297 270H25C11.7452 270 1 280.745 1 294V376C1 389.255 11.7452 400 25 400H297C310.255 400 321 410.745 321 424V506C321 519.255 310.255 530 297 530H25C11.7452 530 1 540.745 1 554V636C1 649.255 11.7452 660 25 660H161.991"
            stroke="black"
            stroke-dasharray="4 4"
            style={svgStyles.path}
          />
          <circle cx="161" cy="10" r="10" fill="#E95444" />
          <circle cx="161" cy="660" r="10" fill="black" />
          <path d="M165 140L150 131L150 149L165 140Z" fill="#E95444" />
          <path d="M165 400L150 391L150 409L165 400Z" fill="#E95444" />
          <path d="M150 270L165 261L165 279L150 270Z" fill="#E95444" />
          <path d="M153 530L168 521L168 539L153 530Z" fill="#E95444" />
          <path d="M93 660L78 651L78 669L93 660Z" fill="#E95444" />
          <path d="M70 10L85 1.00005L85 19L70 10Z" fill="#E95444" />
        </svg>
      )}
    </>
  )
}
export default AnimatedLine
